import { compose, withHandlers, lifecycle } from 'recompose'
import { logout } from 'shared/ducks/user/actions'
import addLoading from 'components/addLoading'
import { setUrl, rpc } from 'shared/actions'
import { profile } from '../../selectors'
import { connect } from 'react-redux'
import { version } from './Terms'
import { message } from 'antd'

export default compose(
  addLoading,
  connect(
    state => ({
      profile: profile(state)
    }),
    { setUrl, rpc, logout }
  ),
  lifecycle({
    componentWillUpdate ({ profile }) {
      if (profile.termsVersion >= version) {
        this.props.setUrl('/')
      }
    }
  }),
  withHandlers({
    submit: ({ rpc, setLoading }) => async version => {
      setLoading(true)
      try {
        await rpc('user.setTermsVersion', { version: parseInt(version, 10) })
      } catch (e) {
        message.error('Something went wrong. Please try again.')
      }
      setLoading(false)
    }
  })
)
